import { hasLongDigitRun } from "./redactCritical";

// Characters that legitimately appear in vehicle makes/models/variants, per a full
// scan of all 59,915 rows of the vehicle-fitment table (TRAC-698): letters, digits,
// whitespace, and the punctuation - . / , ( ) + & : ! _ (nothing else). The data has
// zero non-ASCII characters, so anything outside this set (stray quotes, $, #, smart
// quotes) is safe to drop.
// Mirrors the allow-list in backend _sanitize_query (backend/src/services/ymmv_index.py).
const DISALLOWED_CHARS = /[^A-Za-z0-9\s\-./,()+&:!_]/g;

/**
 * Remove characters that cannot appear in a vehicle make/model/variant.
 *
 * Applied to the search query only (not the visible input), so the user can still
 * type any character and see it in the box while the query we send stays clean.
 * Whitespace normalization is left to the backend matcher; this only strips
 * disallowed characters.
 */
export function sanitizeVehicleQuery(input: string): string {
  // CPOC-140: keystrokes that look like a card number being typed are never sent as a search.
  if (hasLongDigitRun(input)) return "";
  return input.replace(DISALLOWED_CHARS, "");
}
